import { useEffect } from 'react';

import { Logger } from '../../logger/Logger';
import { useCoreDispatch } from '../../store/CoreStore';
import { settingsActions } from '../../store/slices/settings/slice';

// Very Old Browsers and new iPads
interface WebkitDocument extends Document {
  webkitFullscreenElement?: HTMLElement;
  webkitExitFullscreen: () => Promise<void>;
}

// Very Old Browsers and new iPads
interface WebkitElement extends HTMLElement {
  webkitRequestFullscreen: () => Promise<void>;
}

export const toggleFullscreen = (): void => {
  // Close FullScreen
  if (document.fullscreenElement) {
    void document.exitFullscreen();
  } else if ((document as WebkitDocument).webkitFullscreenElement) {
    void (document as WebkitDocument).webkitExitFullscreen();
  } else {
    // Request FullScreen
    Logger.logEvent('click', 'openFullscreen', Date.now(), 1, '', false);
    const element = document.documentElement;
    if (element.requestFullscreen) {
      void element.requestFullscreen();
    } else if ((element as WebkitElement).webkitRequestFullscreen) {
      void (element as WebkitElement).webkitRequestFullscreen();
    }
  }
};

export const useFullscreen = (): void => {
  const dispatch = useCoreDispatch();

  useEffect(() => {
    const handleFullscreenChange = (): void => {
      dispatch(
        settingsActions.setIsInFullscreen(
          !!document.fullscreenElement || !!(document as WebkitDocument).webkitFullscreenElement
        )
      );
    };

    const handleFullscreenError = (): void => {
      Logger.logEvent('fullscreen', 'error', Date.now(), 1, 'Failed to open FullScreen', false);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('fullscreenerror', handleFullscreenError);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);

    return (): void => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('fullscreenerror', handleFullscreenError);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    };
  }, [dispatch]);
};
